<template>
	<div class="wrapper">
		<vs-popup
			:active.sync="showValidationPopup"
			title="Êtes-vous sûr de vouloir supprimer cette job title ?"
		>
			<div class="vx-row">
				<div class="vx-col sm:w-1/2">
					<vs-button class="mt-2 w-full" @click="acceptDeleteMission()"
						>Oui</vs-button
					>
				</div>
				<div class="vx-col sm:w-1/2">
					<vs-button class="mt-2 w-full" @click="showValidationPopup = false"
						>Non</vs-button
					>
				</div>
			</div>
		</vs-popup>
		<div class="flex justify-end space-x-3 mt-3 mb-5">
			<!-- Sliding Input with Transition -->
			<transition name="slide-left">
				<div v-if="showInput">
					<vs-input v-model="newInputUrl" />
				</div>
			</transition>
			<!-- Button -->
			<vs-button @click="toggleInput">
				{{ showInput ? "Enregister" : "Ajouter" }}
			</vs-button>
		</div>
		<vs-table
			max-items="200"
			pagination
			:data="jobs"
			:key="jobTableRefresher"
			noDataText="Aucun(e) Job Title."
		>
			<template slot="thead">
				<vs-th
					class="text-center"
					style="pointer-events: auto"
					sort-key="log_time"
					>Title</vs-th
				>
				<vs-th></vs-th>
			</template>
			<template slot-scope="{ data }">
				<vs-tr
					:data="data[indextr]"
					:key="indextr"
					v-for="(tr, indextr) in data"
				>
					<vs-td class="text-left">{{ data[indextr].job_title }}</vs-td>
					<vs-td class="text-left">
						<vs-button
							size="large"
							color="danger"
							type="flat"
							icon-pack="feather"
							icon="icon-trash-2"
							@click="onclickDeleteJobTitle(tr.id)"
						></vs-button
					></vs-td>
				</vs-tr>
			</template>
		</vs-table>
	</div>
</template>
  
  <script>
export default {
	name: "Logs",
	data() {
		return {
			jobs: [],
			jobTableRefresher: 0,
			showValidationPopup: false,
			jobIdToDelete: null,
			showInput: false,
			newInputUrl: "",
		};
	},
	created() {
		this.fetchJobs();
	},
	methods: {
		async toggleInput() {
			if (!this.showInput)
				this.showInput = !this.showInput; // Toggle the visibility of the input
			else {
				if (this.newInputUrl.length > 0) {
					await this.insertNewJobTitle();
				}
			}
		},
		async insertNewJobTitle() {
			this.$http
				.post(`/prospect/favJobTitle`, {
					job_title: this.newInputUrl,
				})
				.then((response) => {
					this.jobs.unshift({
						job_title: this.newInputUrl,
						id: response.data.insertId,
					});
					this.newInputUrl = "";
					this.jobTableRefresher++;
				})
				.catch((err) => {
					console.log(err);
				});
		},
		fetchJobs() {
			this.$http
				.get(`/prospect/favJobTitle`)
				.then((response) => {
					this.jobs = response.data;
				})
				.catch((err) => {
					console.log(err);
				});
		},
		onclickDeleteJobTitle(id) {
			this.showValidationPopup = true;
			this.jobIdToDelete = id;
		},
		acceptDeleteMission() {
			this.$http
				.delete(`/prospect/favJobTitle?id=${this.jobIdToDelete}`)
				.then((response) => {
					this.jobs = this.jobs.filter((job) => job.id !== this.jobIdToDelete);
					this.showValidationPopup = false;
					this.jobTableRefresher++;
				})
				.catch((err) => {
					console.log(err);
				});
		},
	},
};
</script>
  
  <style scoped>
.slide-left-enter-active,
.slide-left-leave-active {
	transition: all 0.5s ease;
}
.slide-left-enter,
.slide-left-leave-to {
	transform: translateX(-100%);
	opacity: 0;
}
.wrapper {
	text-align: center;
}
</style>